import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import spotify from "../../Assets/Projects/spotify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import tax from "../../Assets/Projects/tax.png";
import ecom from "../../Assets/Projects/ecom.png";
import todos from "../../Assets/Projects/todos.png";
import drib1 from "../../Assets/Projects/drib5.png";

function Projects() {

  return (
    <Container fluid className="project-section">
      <Particle />
    
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
            
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
  
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Spotify-music-search"
              description="The landing page has a login interface for Spotify. After users successfully log in, users are directed to a landing page housing a search bar where they can search for songs or artists. Following the submission of a search request, users receive pertinent responses tailored to their query."
              ghLink="https://github.com/david4u17/spotify-music-search"
              demoLink="https://searchmusic-2d7df.web.app/?trk=public_profile_project-button"            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecom}
              isBlog={false}
              title="E-commerce Website"
              description="This e-commerce website is built on the robust Laravel framework, offers a seamless shopping experience for customers looking to browse and purchase a wide range of products. With a user-friendly interface and intuitive navigation, users can effortlessly explore the extensive catalog, featuring diverse categories and high-quality merchandise."
              ghLink="https://github.com/david4u17/Ecommerce-Website-Laravel-Project"
              demoLink="https://github.com/david4u17/Ecommerce-Website-Laravel-Project"              
            />
          </Col>
                
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todos}
              isBlog={false}
              title="To-do List"
              description="The To-Do List React app is a versatile task management tool that allows users to effortlessly create, update, and delete tasks. With its intuitive interface and comprehensive CRUD operations, users can efficiently organize their tasks, track progress, and enhance productivity."
              ghLink="https://github.com/david4u17/todos-list"
              demoLink="https://todos-list-eight-kappa.vercel.app/"
            />
          </Col>

        

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="User-management-system"
              description="The User Management System is a Laravel and MySQL-based CRUD (Create, Read, Update, Delete) application designed to simplify user administration tasks. With a focus on ease of use and functionality, this system allows users to perform various actions such as listing all users, creating new users, viewing user details, updating user information, and deleting users."
              ghLink="https://github.com/david4u17/User-management-system"
              demoLink="https://github.com/david4u17/User-management-system"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tax}
              isBlog={false}
              title="Income-Tax Calculator"
              description="Income-Tax Calculator is a user-friendly web application designed for effortless tax calculation. With inputs for gross income, additional earnings, age group, and deductions, users can swiftly determine their tax obligations. Robust error handling ensures accuracy, while a responsive layout ensures accessibility across devices. This calculator aims to simplify tax management for individuals."
              ghLink="https://github.com/david4u17/Fyle-challenge"
              demoLink="https://incometaxcalc.netlify.app/"
            />
          </Col>

         <Col md={4} className="project-card">
            <ProjectCard
              imgPath={drib1}
              isBlog={false}
              title="Interactive Static Website"
              description="This project is a static website demonstrating my web development skills, featuring multiple forms, sections, and pages. The design is clean and user-friendly, including a Dribbble sign-up form to showcase form handling capabilities. Built with HTML, CSS, and JavaScript, the site emphasizes responsive design, ensuring compatibility across various devices."
              ghLink="https://github.com/david4u17/dribble-task"
              demoLink="https://dribble-task-iwp.vercel.app/"    
            />
          </Col> 
                
        </Row>
      </Container>
     
    </Container>
  );
}

export default Projects;

